import clsx from "clsx";

const FormInput = ({
  label,
  name,
  type,
  value,
  handleChange,
  disabled = false,
  error,
}) => {
  return (
    <>
      <label
        htmlFor={name}
        className="block text-sm/6 font-medium text-gray-900"
      >
        {label}
      </label>
      <div className="mt-2">
        <input
          id={name}
          name={name}
          type={type}
          onChange={handleChange}
          value={value ? value : ""}
          autoComplete="off"
          disabled={disabled}
          className={clsx(
            error
              ? "outline-red-600"
              : "outline-gray-300 focus:outline-amber-400",
            "block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 sm:text-sm/6"
          )}
        />
      </div>
      {error && <p className="mt-0 text-sm text-red-600">{error}</p>}
    </>
  );
};

export default FormInput;
